// src/components/setting/ProductManagerPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProductManager from './ProductManager';
import AdvertisementManager from './AdvertisementManager';
import shared from '../../styles/shared.module.css';
import styles from './Settings.module.css';

const ProductManagerPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('products'); // 'products' or 'advertisements'

  return (
    <div className={shared.pageContainerWithTabs}>
      <header className={shared.pageHeader}>
        <div className={shared.headerContainer}>
          <h1 className={shared.headerTitle}>BANNAI'S BAR - メニュー管理</h1>
          <button
            onClick={() => navigate('/dashboard')}
            className={`${shared.backButton} ${styles.backButton}`}
          >
            戻る
          </button>
        </div>
      </header>

      <main className={shared.mainContentWithTabs}>
        {/* タブナビゲーション（固定） */}
        <div className={styles.tabContainer}>
          <button
            className={`${styles.tabButton} ${activeTab === 'products' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveTab('products')}
          >
            メニュー管理
          </button>
          <button
            className={`${styles.tabButton} ${activeTab === 'advertisements' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveTab('advertisements')}
          >
            広告管理
          </button>
        </div>

        {/* タブの中身のみスクロール */}
        <div className={shared.tabContentScroll}>
          {activeTab === 'products' ? (
            <ProductManager />
          ) : (
            <AdvertisementManager />
          )}
        </div>
      </main>
    </div>
  );
};

export default ProductManagerPage;